//query param is there for cache busting, when updating the image change it to another random string
export const DEFAULT_OG_IMAGE = `${process.env.NEXT_PUBLIC_FRONTEND_URL}/authory_static_files/images/og_profiles.png?cachebust=huwadnsm`;